module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-list-form filter-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Client")]), _c('input-form', {
    attrs: {
      "fields": ['query'],
      "placeholders": ['Client search']
    },
    on: {
      "updatedData": _vm.setSearch
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "selected": "selected"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Status")]), _c('option', [_vm._v("ACTIVE")]), _c('option', [_vm._v("SUSPENDED")]), _c('option', [_vm._v("CANCELED")]), _c('option', [_vm._v("ON HOLD")])])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Client type")]), _c('SelectizeClientType', {
    on: {
      "optionSelected": _vm.setClientType,
      "optionRemoved": function($event) {
        _vm.search.client_type = null
      }
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [_c('a', {
    staticClass: "fa fa-filter fa-2x",
    on: {
      "click": _vm.setFilters
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39a7340b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/filters/ClientListForm.vue
// module id = 2418
// module chunks = 1